export const AUTH_TOKEN = 'authToken';
export const REFRESH_TOKEN = 'refreshToken';
export const USER_DATA = 'user';
export const FCM_USER = 'FCM_USER';
